import Text from '@commons/components/Text';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

import styles from './Title.module.scss';

/**
 * InsightsTitle field block.
 *
 * Splits the title in half to apply a color to the second half.
 */

const InsightTitle = ({ content }: DrupalBlock<DrupalText>) => {
  if (!content?.value) return null;

  const words = content.value.split(' ');
  const firstHalf = words.slice(0, Math.ceil(words.length / 2)).join(' ');
  const secondHalf = words.slice(Math.ceil(words.length / 2)).join(' ');

  return (
    <Text as="h1" transform="uppercase" marginBottom="none" className={styles.title}>
      {firstHalf}
      {` `}
      <span className={styles.colored}>{secondHalf}</span>
    </Text>
  );
};

export default InsightTitle;
